import { render, staticRenderFns } from "./DownloadPreventButton.vue?vue&type=template&id=69a56c5b&scoped=true"
import script from "./DownloadPreventButton.vue?vue&type=script&lang=ts"
export * from "./DownloadPreventButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a56c5b",
  null
  
)

export default component.exports